<template lang="pug">
  .account
    van-nav-bar(
      :title="$t('account.title')"
      @click-left="openSidenav"
      @click-right="checkForm")
      van-icon(name="menu" slot="left")
      van-icon(name="save" slot="right")

    .main.padding-quadruple-bottom
      .van-cell-group__title {{ $t('account.title') }}

      van-cell-group
        //- Nombre input
        van-field(
          input-align="right"
          name="name"
          v-model="user.name"
          v-validate="'required|max:35|min:2'"
          :data-vv-as="$t('account.name')"
          :label="$t('account.name')"
          :class="{'error': errors.has('name') }"
          :placeholder="$t('account.name')")

        //- Apellidos input
        van-field(
          input-align="right"
          name="lastName"
          v-model="user.lastName"
          v-validate="'required|max:35|min:2'"
          :data-vv-as="$t('account.lastName')"
          :label="$t('account.lastName')"
          :class="{'error': errors.has('lastName') }"
          :placeholder="$t('account.lastName')")

        //- Email input
        van-field(
          input-align="right"
          v-model="user.email"
          :label="$t('account.email')"
          :placeholder="$t('account.email')"
          disabled)

        //- Recibir email de soporte
        van-switch-cell.account__commercial(
          v-if="showSupportEmail"
          v-model="user.support"
          :title="$t('account.support')")

        //- Recibir email comerciales
        van-switch-cell.account__commercial(
          v-model="user.commercial"
          :title="$t('account.commercial')")

      .padding-halve-top.padding-halve-bottom
        .auth__error(v-show="errors.has('name')") {{ errors.first('name') }}
        .auth__error(v-show="errors.has('lastName')") {{ errors.first('lastName') }}


    .button-bottom-group
      .button-bottom.text-danger(@click="confirmDeleteAccount") {{ $t('account.deleteAccount') }}
</template>

<script>
import i18n from '@/locales/i18n';
import { mapGetters, mapActions } from 'vuex';
import { getErrorId } from '@/services/error.service';
import UserService from '@/services/user.service';
import { CONFIG } from '@/app.config';

export default {
  data() {
    return {
      showSupportEmail: CONFIG.SHOW_SUPPORT_EMAIL,
      authError: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'userModule/getUser',
      isDemo: 'globalModule/isDemo',
    }),
  },
  methods: {
    ...mapActions({
      openSidenav: 'globalModule/openSidenav',
    }),

    /**
     * Compruebo si los datos del formulario son válidos
     */
    checkForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.editUser();
        }
      });
    },

    /**
     * Intento editar los datos del usuario
     */
    async editUser() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;
        this.authError = null;

        const user = {
          name: this.user.name,
          lastName: this.user.lastName,
          email: this.user.email,
          commercial: this.user.commercial,
          support: this.showSupportEmail ? this.user.support : true,
        };

        // Realizo la petición
        await UserService.editUser(user);

        this.$toast.clear();
        this.$toast.success({ mask: true, message: i18n.t('account.success') });
      } catch (error) {
        // Obtengo el error
        this.authError = getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: i18n.t('account.fail') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Confirma si realmente quiere eliminar la cuenta del usuario
     */
    confirmDeleteAccount() {
      if (this.isDemo) {
        this.$dialog.alert({
          title: i18n.t('errors.demoNotAllowed.title'),
          message: i18n.t('errors.demoNotAllowed.message'),
        });
        return;
      }

      this.$dialog
        .confirm({
          title: i18n.t('account.delete.title'),
          message: i18n.t('account.delete.message'),
        })
        .then(() => {
          this.deleteAccount();
        });
    },

    /**
     * Intento eliminar al usuario
     */
    async deleteAccount() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;
        this.authError = null;

        // Realizo la petición
        await UserService.deleteUser();

        this.$toast.clear();
        this.$router.push({
          name: 'login',
          query: { reaseon: 'deleteAccount' },
        });
      } catch (error) {
        // Obtengo el error
        this.authError = getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: i18n.t('account.fail') });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
